import { FilterConfigFixed } from '@/types/filter';
import { FilterValue } from '@/models';
import { HCP_SCIENTIFIC_ACTIVITY_SCORE } from '@/api/hcp';
import Stars from '@/components/shared/rating/Stars/Stars';

const congressFilter: FilterConfigFixed = {
  label: 'global.filters.formControls.congressLabel',
  placeholder: 'global.filters.formControls.congressPlaceholder',
  type: 'levelselect',
  defaultValue: null,
  filterGroup: 'scientificActivities',
  format: ({ value, t }) => (
    <>
      <span>{t('global.filters.congress')}</span>
      <Stars value={parseInt(String(value ?? 0))} />
    </>
  ),

  applyFilter: (filterValue: FilterValue) => {
    const ratingScore = Number(filterValue) || 0;

    return {
      and: [
        {
          member: `${HCP_SCIENTIFIC_ACTIVITY_SCORE}.score_category`,
          operator: 'equals',
          values: ['conference_speaker'],
        },
        {
          member: `${HCP_SCIENTIFIC_ACTIVITY_SCORE}.score_label`,
          operator: 'equals',
          values: ['national score'],
        },
        {
          member: `${HCP_SCIENTIFIC_ACTIVITY_SCORE}.score_value`,
          operator: 'gte',
          values: [ratingScore.toString()],
        },
      ],
    };
  },
};

export default congressFilter;
